
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4DJgG", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $917b9bb03b3149d5$var$logger = (0, $7W8i8.getLogger)('inline-comment');
const $917b9bb03b3149d5$export$dbde27c406dff8e8 = ({ content: content, contentId: contentId, commentToReattach: commentToReattach, actions: actions })=>{
    let selectionObj = {
        numMatches: 0,
        matchIndex: -1,
        selectedText: '',
        timestamp: 0
    };
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        $917b9bb03b3149d5$var$logger.debug`No text selected. Creating inline comment at cursor position.`;
        return selectionObj;
    }
    if (selection) {
        // TODO clean up after above FG is removed
        const range = selection.getRangeAt(0);
        const legacySelection = (0, $aUTn5.convertSelectionToLegacyFormat)(content.current, range, contentId);
        const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = legacySelection;
        selectionObj = {
            numMatches: numMatches,
            matchIndex: matchIndex,
            selectedText: selectedText,
            timestamp: Date.now()
        };
        /**
     * We generate the annotation step for the upcoming new collab service
     * to consume. This means we will eventually started sending markerRef
     * ids from the FE.
     */ try {
            const markerRef = commentToReattach ? commentToReattach.inlineMarkerRef : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            if (actions) {
                const proseMirrorStep = actions.annotate(range, markerRef, 'inlineComment');
                const { step: { from: from, to: to, mark: mark } } = proseMirrorStep;
                selectionObj['step'] = {
                    from: from,
                    to: to,
                    mark: {
                        type: 'annotation',
                        attrs: {
                            key: mark.attrs?.annotationType,
                            value: mark.attrs?.id
                        }
                    }
                };
            }
        } catch (e) {
            $917b9bb03b3149d5$var$logger.error`An error occurred when generating a step - ${e}`;
        }
    }
    return selectionObj;
};
module.exports["getLegacyConvertedSelectionObj"] = $917b9bb03b3149d5$export$dbde27c406dff8e8;

});

parcelRegister("2Awp2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");

var $8tSmd = parcelRequire("8tSmd");

var $48SU7 = parcelRequire("48SU7");

var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");

var $iIVVb = parcelRequire("iIVVb");


var $g5gZt = parcelRequire("g5gZt");








var $lAFHW = parcelRequire("lAFHW");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $8dvlB = parcelRequire("8dvlB");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $inPa6 = parcelRequire("inPa6");


var $2Rith = parcelRequire("2Rith");


var $1iSzD = parcelRequire("1iSzD");


var $abUsF = parcelRequire("abUsF");


var $5qqdA = parcelRequire("5qqdA");


var $eqKgz = parcelRequire("eqKgz");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $2A8CJ = parcelRequire("2A8CJ");


var $hrAmX = parcelRequire("hrAmX");


var $hl1Kw = parcelRequire("hl1Kw");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cMvMc = parcelRequire("cMvMc");


var $dANtQ = parcelRequire("dANtQ");


var $kRW4Y = parcelRequire("kRW4Y");


var $jmjWc = parcelRequire("jmjWc");


var $7W8i8 = parcelRequire("7W8i8");


var $2Jxlo = parcelRequire("2Jxlo");


var $a3Fla = parcelRequire("a3Fla");

parcelRequire("9ikgN");
var $cR1lV = parcelRequire("cR1lV");
var $9ikgN = parcelRequire("9ikgN");


var $7rLBD = parcelRequire("7rLBD");


var $bjVRl = parcelRequire("bjVRl");


var $9oxdN = parcelRequire("9oxdN");


var $7Sm4c = parcelRequire("7Sm4c");


var $eDk57 = parcelRequire("eDk57");


var $98CLM = parcelRequire("98CLM");


var $aiS08 = parcelRequire("aiS08");


var $jln20 = parcelRequire("jln20");


var $7mpOv = parcelRequire("7mpOv");


var $lJlG6 = parcelRequire("lJlG6");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $cZa7r = parcelRequire("cZa7r");


var $b0EGa = parcelRequire("b0EGa");


var $aKDZB = parcelRequire("aKDZB");


var $erJgi = parcelRequire("erJgi");


var $dnbZ2 = parcelRequire("dnbZ2");


var $3b5i6 = parcelRequire("3b5i6");


var $4DJgG = parcelRequire("4DJgG");


var $6W81y = parcelRequire("6W81y");


var $4oXkq = parcelRequire("4oXkq");


var $9ujb2 = parcelRequire("9ujb2");


var $lEDve = parcelRequire("lEDve");


var $bEdUx = parcelRequire("bEdUx");


var $2W2Mk = parcelRequire("2W2Mk");


var $l4eiF = parcelRequire("l4eiF");


var $2zMIV = parcelRequire("2zMIV");


var $b1ynj = parcelRequire("b1ynj");


var $dj3mI = parcelRequire("dj3mI");


var $6zmDz = parcelRequire("6zmDz");


var $97kfW = parcelRequire("97kfW");


var $joYQz = parcelRequire("joYQz");

const $9755f908a54a6c5b$var$builtInActionsStyles = null;
const $9755f908a54a6c5b$var$builtInActionsWithoutOtherActionsStyles = null;
const $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD = 100;
const $9755f908a54a6c5b$var$BUILT_IN_ITEMS = [
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary',
    'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
];
const $9755f908a54a6c5b$export$9205c47465d0942 = [
    'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary'
];
const $9755f908a54a6c5b$var$i18n = (0, $aXWIB.defineMessages)({
    commentTooltip: {
        id: "highlight-actions.inline.comment.tooltip",
        defaultMessage: "Comment"
    },
    defineTooltip: {
        id: "highlight-actions.define.tooltip",
        defaultMessage: "Define"
    }
});
const $9755f908a54a6c5b$var$logger = (0, $7W8i8.getLogger)('inline-comment');

const $9755f908a54a6c5b$var$ForgeAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wTC7w",
    name: "ForgeAction",
    loader: async ()=>(await (parcelRequire("5iBet"))).ForgeAction
});

const $9755f908a54a6c5b$var$DefinitionAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wKsW8",
    name: "DefinitionAction",
    loader: async ()=>(await (parcelRequire("41AE3"))).DefinitionAction
});
const $9755f908a54a6c5b$export$c1823fc1996a2ebd = (evt)=>{
    const highlightActionsToolbar = document.querySelector('[data-testid="highlightActionsPopup"]');
    const focusedElement = document.activeElement;
    if (highlightActionsToolbar && !highlightActionsToolbar?.contains(focusedElement) && evt.key === 'Tab' && !evt.ctrlKey && !evt.altKey) {
        evt.preventDefault();
        document.querySelector('[data-testid="createInlineCommentButton"]')?.focus();
    }
};
function $9755f908a54a6c5b$var$trapFocusInSelectionToolbar(event) {
    const highlightActionsToolbar = document.querySelector('#highlightActionsPopup');
    if (highlightActionsToolbar && event.key === 'Tab' && !event.ctrlKey && !event.altKey) {
        event.preventDefault();
        event.stopPropagation(); // Get all focusable elements in the toolbar
        const elements = Array.from(highlightActionsToolbar.querySelectorAll('button, a')).filter((curr)=>{
            if (curr instanceof HTMLButtonElement) return !curr.disabled;
            if (curr instanceof HTMLAnchorElement) return !!curr.href;
            return false;
        }); // Find the index of the currently focused element
        let idx = event.shiftKey ? elements.length : -1;
        const focusedElement = document.activeElement;
        if (highlightActionsToolbar.contains(focusedElement)) {
            for(let i = 0; i < elements.length; i++)if (elements[i] === focusedElement) {
                idx = i;
                break;
            }
        } // Focus the next element to focus
        event.shiftKey ? idx-- : idx++;
        if (idx < 0) idx = elements.length - 1;
        else if (idx >= elements.length) idx = 0;
        const next = elements[idx];
        if (next && (next instanceof HTMLButtonElement || next instanceof HTMLAnchorElement)) next.focus();
    }
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $afneb.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $afneb.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rko12b0 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rko12b0 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $9755f908a54a6c5b$export$c0b63e9f99a74f33 = (components, hasOtherActions)=>{
    const dividerLast = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.Divider), {
        key: "divider-last",
        "data-testid": "divider-last"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DividerOld), {
        key: "divider-last",
        "data-testid": "divider-last"
    });
    return components.reduce((result, component, i)=>{
        // Add the current component
        result.push(component); // Add a divider after each component except the last one
        if (i < components.length - 1) result.push((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.Divider), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DividerOld), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }));
        return result; // If there are other actions, add a divider at the end
    }, []).concat(hasOtherActions ? dividerLast : []);
};
const $9755f908a54a6c5b$export$a6299569dd2a354f = ({ contentId: contentId, children: children, hasInlineComments: hasInlineComments = true, actions: actions, lastModifiedDate: lastModifiedDate, isArchived: isArchived, contentStatusError: contentStatusError, range: range, isAnnotationAllowed: isAnnotationAllowed, onCommentButtonPress: onCommentButtonPress, onRemixButtonPress: onRemixButtonPress, remixDisabledReason: remixDisabledReason, isRemixInProgress: isRemixInProgressProp, isFabric: isFabric, contentType: contentType, inlineNodeTypes: inlineNodeTypes, onCommentButtonMount: onCommentButtonMount, snippetSlots: snippetSlots })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    const [actionStates, setActionStates] = (0, $42omo.useState)({
        firstHighlightShown: false,
        show: false,
        top: 0,
        left: 0,
        forgeExtension: null,
        activeSelection: null,
        selectionRect: null,
        isReadingAidsOpen: false,
        readingAidsChangeboardingStep: 'disabled'
    });
    const [position, setPosition] = (0, $42omo.useState)(null);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach, isInReattachMode: isInReattachMode } = (0, $brNvA.useReattachComment)();
    const { setReattachHighlight: setReattachHighlight } = (0, $brNvA.useReattachCommentDispatch)();
    const { lastModificationDate: lastModificationDate } = (0, $42omo.useContext)((0, $2A8CJ.ContentBodyContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { canAddComments: canAddComments, contentQueryError: contentQueryError } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
    });
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [isWarningDialogOpen, setIsWarningDialogOpen] = (0, $42omo.useState)(false);
    const [recordedClick, setRecordedClick] = (0, $42omo.useState)(); // Flag to trigger text comment creation after media comment cleanup
    const [pendingTextComment, setPendingTextComment] = (0, $42omo.useState)(false);
    const { setDefineDefinitionOpen: setDefineDefinitionOpen } = (0, $bjVRl.useReadingAidsActions)();
    const { hoverProps: hoverProps } = (0, $cZa7r.useAnnotations)();
    const { setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { isRemixing: isRemixingFromContext } = (0, $aKDZB.useRendererRemixContext)();
    const isRemixing = isRemixInProgressProp || isRemixingFromContext;
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const { firstHighlightShown: firstHighlightShown, show: show, top: top, left: left, forgeExtension: forgeExtension, activeSelection: activeSelection, selectionRect: selectionRect, isReadingAidsOpen: isReadingAidsOpen, readingAidsChangeboardingStep: readingAidsChangeboardingStep } = actionStates;
    const mountedRef = (0, $42omo.useRef)(false);
    const screenEventFiredRef = (0, $42omo.useRef)(false);
    const highlightActionsShownRef = (0, $42omo.useRef)(false);
    const content = (0, $42omo.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const [showReadingAidsChangeboarding, stopReadingAidsChangeboarding] = (0, $9oxdN.useFeatureDiscovery)('highlight-actions.reading-aids.changeboarding');
    const isReadingAidsChangeboardingActive = readingAidsChangeboardingStep.match(/^modal|spotlight/); // Sync popup visibility to OmniBar's visibility store (counter-based)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    const shouldHideOmniBar = show || isReadingAidsOpen || !!forgeExtension;
    (0, $42omo.useLayoutEffect)(()=>{
        if (shouldHideOmniBar && (0, $9wGTI.fg)('cc-engagement-omnibar-hide-highlight-actions')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        shouldHideOmniBar,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const highlightActionsContextValue = (0, $42omo.useMemo)(()=>({
            firstHighlightShown: firstHighlightShown
        }), [
        firstHighlightShown
    ]); // start the reading aids changeboarding
    (0, $42omo.useEffect)(()=>{
        setActionStates((prevState)=>({
                ...prevState,
                readingAidsChangeboardingStep: showReadingAidsChangeboarding && isAIEnabledForContent ? 'idle' : 'disabled'
            }));
    }, [
        showReadingAidsChangeboarding,
        isAIEnabledForContent
    ]);
    (0, $42omo.useEffect)(()=>{
        // Manually trigger resize to ensure spotlight is properly aligned
        window.setTimeout(()=>window.dispatchEvent(new Event('resize')), 0);
        if (!show) {
            // Force a redraw of portalContainer, which fixes an issue where the popup is removed from DOM but is
            // still visible on the page __in Safari__. (https://product-fabric.atlassian.net/browse/COMMENTS-5335)
            // This rendering issue occurring in Safari's WebKit engine seems to be known and has a long history.
            // Only do this when `show === false`, since the issue only occurs when attepmting to hide the popup.
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
            if (portalContainer) {
                portalContainer.style.transform = 'translateZ(0)'; // This line below reads this layout property, which triggers a reflow + redraw as side effect.
                portalContainer.offsetHeight; // NOSONAR - Sonar would complain: "Expected an assignment or function call and instead saw an expression"
                portalContainer.style.transform = '';
            }
        }
    }, [
        show
    ]); // freeze the user's selection while reading aids changeboarding is active
    (0, $42omo.useEffect)(()=>{
        const akPortalContainer = document.querySelector('.atlaskit-portal-container');
        if (akPortalContainer) {
            if (isReadingAidsChangeboardingActive) {
                akPortalContainer.style.userSelect = 'none';
                return ()=>{
                    akPortalContainer.style.userSelect = 'auto';
                };
            } else akPortalContainer.style.userSelect = 'auto';
        }
    }, [
        isReadingAidsChangeboardingActive
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
            document.addEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            return ()=>{
                document.removeEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            };
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('highlight-actions.container.resized', onContainerResized);
        return ()=>{
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('highlight-actions.container.resized', onContainerResized);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentToReattach,
        isReadingAidsChangeboardingActive,
        isRemixing
    ]); /* When nudgebar improvement is on: hide toolbar when selection was set by comment nudge (e.g. on hover). */ 
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
        const onSelectionChange = ()=>{
            if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && mountedRef.current) setActionStates((prev)=>({
                    ...prev,
                    show: false
                }));
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>document.removeEventListener('selectionchange', onSelectionChange);
    }, []); // Close reading aids popup when navigating to another page
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        };
    }, [
        contentId,
        setDefineDefinitionOpen
    ]); // Handle text comment creation after media comment cleanup is complete
    (0, $42omo.useEffect)(()=>{
        if (pendingTextComment && !hoverProps) {
            setPendingTextComment(false);
            if (isFabric) onCommentButtonPress?.();
            else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach,
                actions: actions
            }));
        }
    }, [
        pendingTextComment,
        hoverProps,
        isFabric,
        onCommentButtonPress,
        createComment,
        content,
        contentId,
        commentToReattach,
        actions
    ]);
    const onContainerResized = ()=>{
        setActionStates((prevState)=>({
                ...prevState,
                show: false,
                forgeExtension: null
            }));
    };
    function getScrollParent(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE && node.scrollWidth > node.clientWidth) return node;
        else return getScrollParent(node.parentNode);
    }
    function getParentNode(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE) return node;
        else return getParentNode(node.parentNode);
    }
    const getPosition = (range)=>{
        const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
        const portalRect = portalContainer?.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        const { left: leftRect, top: topRect, width: width, height: height } = range.getBoundingClientRect(); // Popup can't be rendered outside the body area
        const contentRect = getParentNode(range.commonAncestorContainer).getBoundingClientRect();
        let leftLimit = contentRect.left;
        let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
        // The popup is limited to be shown within the scrollable area.
        const firstParentThatCanScroll = getScrollParent(range.startContainer);
        if (firstParentThatCanScroll) {
            const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
            leftLimit = Math.max(leftLimit, scrollParentRect.left);
            rightLimit = Math.min(rightLimit, scrollParentRect.right);
        }
        let x = width / 2 + leftRect;
        if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
        return {
            pos: {
                left: x - portalRect.left,
                top: topRect - portalRect.top
            },
            selectionRect: {
                left: x - portalRect.left,
                top: topRect - portalRect.top,
                width: width,
                height: height
            }
        };
    };
    (0, $42omo.useEffect)(()=>{
        if (range) {
            /* When nudgebar improvement is on, never show toolbar for selection set by nudge (range can come from parent when we set selection on comment hover). */ if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) {
                setPosition(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const { pos: pos, selectionRect: selectionRectangle } = getPosition(range);
            highlightActionsShownRef.current = false;
            setPosition(pos);
            setActionStates((prevState)=>({
                    ...prevState,
                    selectionRect: selectionRectangle,
                    show: true
                }));
        } else {
            setPosition(null);
            setActionStates((prevState)=>({
                    ...prevState,
                    show: false
                }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const updatePosition = (0, $42omo.useCallback)(()=>{
        if (range) {
            const { pos: pos } = getPosition(range);
            setPosition(pos);
            return pos;
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const prepareAndSetHighlightForReattachMode = ()=>{
        const convertedSelectionObj = (0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }); // Only set the highlight if it's valid
        if (convertedSelectionObj.numMatches > 0 && convertedSelectionObj.matchIndex !== -1) setReattachHighlight(convertedSelectionObj);
    };
    const isDatasourceHighlighted = (range)=>{
        const datasourceContainers = document.querySelectorAll('.datasource-table');
        return Array.from(datasourceContainers).some((container)=>container.contains(range.startContainer) || container.contains(range.endContainer));
    };
    const onMouseUp = (e)=>{
        return requestAnimationFrame(()=>{
            if (!mountedRef.current) return;
            if ((0, $9wGTI.fg)('quick_capture_trello_inbox')) (0, $9ujb2.prefetchTrelloAccess)();
            const range = (0, $2zMIV.getRange)();
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`); // WS-1576/WS-2355 - Ignore any highlights in the Inline Comments sidebar
            const inlineCommentSidebarContainer = document.querySelector('#inline-comment-sidebar'); // InlineCommentNudge handles its own content selection and opening of the Comment Editor.
            // Check both event target and element under cursor so we don't show toolbar when pointer is over nudge (e.g. portal/overlay edge cases).
            const elementUnderCursor = typeof document.elementFromPoint === 'function' ? document.elementFromPoint(e.clientX, e.clientY) : null;
            const isOverCommentNudge = e.target && e.target.closest?.('#inline-comment-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-comment-nudge');
            const isOverRemixNudge = e.target && e.target.closest?.('#inline-remix-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-remix-nudge');
            if (isOverCommentNudge) return;
            if (isOverRemixNudge && (0, $9wGTI.fg)('confluence_remix_button_right_side_block_fg')) return;
             // When nudgebar improvement is on, only show toolbar when user selected text (not when selection was set by nudge hover).
            if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
             // freeze the actions popup if reading aids changeboarding is active
            if (isReadingAidsChangeboardingActive) return;
             // freeze the actions popup if the input is clicked in the rovo chat more options popup
            if (e.target.closest('#context-menu-rovo-chat-custom-prompt')) return;
            const isCommentButtonDisabledAndClicked = e.target.closest('button[disabled]');
            const isContextMenuOtherAppsButtonClicked = e.target.closest('#context-menu-other-apps');
            const isCreateJiraIssueButtonClicked = e.target.closest('#create-jira-issue-trigger');
            const isRovoChatMoreOptionsButtonClicked = e.target.closest('#context-menu-rovo-chat-more-options');
            const isNotesButtonClicked = e.target.closest('#highlight-actions-notes-button');
            const shouldHideContextMenu = !(isCommentButtonDisabledAndClicked || isContextMenuOtherAppsButtonClicked || isCreateJiraIssueButtonClicked || isRovoChatMoreOptionsButtonClicked || isNotesButtonClicked);
            if (!range || !portalContainer || !content.current || inlineCommentSidebarContainer?.contains(range.startContainer) || inlineCommentSidebarContainer?.contains(range.endContainer) || isDatasourceHighlighted(range) || !content.current.contains(e.target) && content.current !== e.target && shouldHideContextMenu) {
                if (isInReattachMode()) setReattachHighlight(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // COMMENTS-332 - In reattach mode, skip the measuring of the screen, just set the mode with the highlight
            if (isInReattachMode()) {
                prepareAndSetHighlightForReattachMode();
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const portalRect = portalContainer.getBoundingClientRect();
            const contentRect = content.current.getBoundingClientRect();
            const rects = range.getClientRects();
            if (!rects || !rects.length) {
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // Find first selection area that width is not 0
            // Sometimes there is a chance that user is selecting an empty DOM node.
            const rect = Array.from(rects).find((rect)=>rect.width !== 0 && rect.height !== 0);
            if (rect) {
                const { left: left, right: right, top: top, width: width, height: height } = rect;
                const mouseUpX = e.clientX; // This is a LEGACY disable statement after rule addition. Use `Math.floor(width/2)` next time
                // eslint-disable-next-line no-bitwise
                const selectedLineCenter = left + (width >> 1); // Popup can't be rendered outside the body area
                let leftLimit = contentRect.left;
                let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
                // The popup is limited to be shown within the scrollable area.
                const firstParentThatCanScroll = getScrollParent(range.startContainer);
                if (firstParentThatCanScroll) {
                    const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
                    leftLimit = Math.max(leftLimit, scrollParentRect.left);
                    rightLimit = Math.min(rightLimit, scrollParentRect.right);
                } // Use the X-axis position if the center of selected line is POPUP_MOUSEUP_DISTANCE_THRESHOLD away from mouse up position.
                // POPUP_MOUSEUP_DISTANCE_THRESHOLD is an arbitrary number I made up.
                // The idea is the popup will always show up within POPUP_MOUSEUP_DISTANCE_THRESHOLD of the end of the selection.
                // Right near what user selects. However when the selection is too short - like a phase,
                // it will show up at the middle of the selection because it looks better.
                let x = Math.abs(mouseUpX - selectedLineCenter) > $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD && left <= mouseUpX && mouseUpX <= right ? mouseUpX : selectedLineCenter; // However it is still bounded by the left and right boundary of the first line.
                // This is because the mouse up can be off screen.
                // For example: Make selection, then drag on a scroll bar.
                if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
                if (!isFabric) highlightActionsShownRef.current = false;
                setActionStates((prevState)=>({
                        ...prevState,
                        firstHighlightShown: true,
                        // COMMENTS-332 - Don't show the popup when a selection is made in reattach mode
                        show: !isInReattachMode(),
                        left: x - portalRect.left,
                        top: top - portalRect.top,
                        selectionRect: {
                            left: x - portalRect.left,
                            top: top - portalRect.top,
                            width: width,
                            height: height
                        }
                    }));
            }
        });
    };
    const createReactInlineCommentHighlight = ()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
         // Close any existing media create comment when opening a text comment
        if ((0, $6mKj3.expValEquals)('confluence_comment_unmount_onmedia_selection', 'isEnabled', true)) {
            if (hoverProps) {
                // Remove draft annotation from media element if it exists
                hoverProps.removeDraftMode?.(); // Close the hover component (calls renderer's onClose)
                hoverProps.onClose?.(); // Clear hoverProps from context
                setHoverProps(null); // Flag to trigger text comment creation after hoverProps is cleared
                setPendingTextComment(true);
                return;
            }
        } // Proceed with text comment creation immediately if no media comment to clean up
        if (isFabric) onCommentButtonPress?.();
        else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }));
    };
    const handleCommentButtonClick = (dialogs)=>{
        if (hasContentChanged) dialogs.showDialog((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight()
        });
        else createReactInlineCommentHighlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'highlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createInlineCommentFromHighlightActionsMenu',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    pageMode: 'view',
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                }
            }
        }).fire();
    };
    const extractNodeDetailsToString = (node)=>{
        if (!node) return '';
        while(node?.nodeType === Node.TEXT_NODE || node.tagName === 'MARK')node = node?.parentNode;
        if (node) {
            const elem = node;
            const classListStr = Array.from(elem.classList).join(',');
            let attrListStr = '';
            Object.entries(elem.dataset).forEach((attrEntry, idx)=>{
                if (idx > 0) attrListStr += ',';
                 // COMMENTS-1916 - Remove any emails that are in any values for attributes
                if (attrEntry.length > 1) {
                    const field = attrEntry[0];
                    if (field && field.includes('testMediaName')) attrEntry[1] = '';
                }
                attrListStr += attrEntry.join('=');
            }); // Get the tag name and stringify the class list and attribute list
            return `${elem.tagName}${classListStr.length ? `.${classListStr}` : ''}${attrListStr.length ? `[${attrListStr}]` : ''}`;
        }
        return '';
    };
    const CreateInlineCommentButton = ()=>{
        const { documentNeedsUpdate: documentNeedsUpdate, currentDocumentVersion: currentDocumentVersion, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
        (0, $42omo.useEffect)(()=>{
            if (!(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                document.addEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                return ()=>{
                    document.removeEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                };
            }
        }, []);
        (0, $42omo.useEffect)(()=>{
            onCommentButtonMount && onCommentButtonMount();
        }, []);
        if (!content.current) return null;
        const isHighlightValid = isFabric ? isAnnotationAllowed : (0, $2zMIV.isHighlightValidForInlineComment)(content.current, contentId);
        const shouldDisableCommentWhenDocumentNeedsUpdate = (selectedInlineNodeTypes)=>{
            // If document is outdated, only disable the comment button when selection is exactly 1 of the 4 types below.
            return selectedInlineNodeTypes?.length === 1 && [
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(selectedInlineNodeTypes[0]);
        }; // Cases where we want to disable the create button:
        // 1. The content is archived.
        // 2. The user does not have the "Comment - Add" permission.
        // 3. The highlight was invalid (over elements we don't support commenting on).
        // 4. The document needs to be updated (i.e. is outdated) AND selected node is one of [status, date, mention, inlineCard].
        // This order matters when communicating to users, as checking "Comment - Add" permission for archived pages
        // will return false.
        const needsUpdateToComment = shouldDisableCommentWhenDocumentNeedsUpdate(inlineNodeTypes) && (!!documentNeedsUpdate && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true) || currentDocumentVersion !== publishedDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true));
        const isCreateButtonEnabled = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid; // Check if the comment is on a selection that includes an non-text inline node
        const isNonTextInlineNodeIncludedInComment = (inlineNodeTypes ?? []).filter((nodeType)=>nodeType !== 'text').length > 0; // Track the nodes in which the highlight was made on to send in the event
        if (!highlightActionsShownRef.current) {
            highlightActionsShownRef.current = true;
            try {
                const selection = window.getSelection();
                const startingNode = extractNodeDetailsToString(selection?.anchorNode);
                const endingNode = extractNodeDetailsToString(selection?.focusNode); // Track when the menu is shown to users and if it's disabled
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'shown',
                        actionSubject: 'toolbar',
                        actionSubjectId: 'highlightActionsMenu',
                        attributes: {
                            isDisabled: !isCreateButtonEnabled,
                            pageMode: 'view',
                            startingNode: startingNode,
                            endingNode: endingNode,
                            inlineNodeTypes: inlineNodeTypes,
                            isNonTextInlineNodeIncludedInComment: /**
               * This attribute is used as the trigger to display an engagement platform promotion message
               * when isNonTextInlineNodeIncludedInComment is true, and isDisabled is false,
               * A spotlight/flag will be shown to the user to encourage them to comment on inline nodes.
               */ isNonTextInlineNodeIncludedInComment
                        }
                    }
                }).fire();
            } catch (e) {
                $9755f908a54a6c5b$var$logger.error`Unable to send highlight actions event; ${e}`;
            }
        }
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>{
            const commonCreateButtonProps = {
                'data-key': 'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
                // Needed for integration tests
                isDisabled: !isCreateButtonEnabled,
                testId: 'createInlineCommentButton',
                interactionName: 'start-inline-comment-action',
                onClick: ()=>{
                    handleCommentButtonClick(dialogs);
                },
                id: 'create-inline-comment-button'
            };
            return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
                ...commonCreateButtonProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...commonCreateButtonProps,
                appearance: "subtle",
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                        label: ""
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            })));
        }); // WS-2802 - We need to wrap the disabled button and put a transparent absolute overlay over the button
        //           in order to show the tooltip correctly as the disabled button swallows all events on the element
        //           and ADG doesn't allow tooltips on disabled buttons for accessibility reasons...
        if (isNewToolbarEnabled) return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            delay: 0,
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
        return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
    };
    const createJiraIssueButton = (completeKey)=>{
        if (!content.current || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        if (!(0, $1xpoY.default).getBoolean('confluence_legacy_single_jira_work_create', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
            config: {
                // Required configuration
                product: 'confluence',
                subproduct: 'jira',
                aiFeatureName: 'confluenceAiWorkCreation',
                proactiveGeneratedAI: 0,
                userGeneratedAI: 1,
                // Optional configuration
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6W81y.CreateJiraIssueActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            container: content.current,
            contentId: contentId,
            contentType: contentType,
            lastModified: lastModifiedDate || lastModificationDate,
            showCreateMultipleIssuesButton: (0, $2zMIV.isHighlightValidForBulkCreateJiraIssues)(),
            setRecordedClick: setRecordedClick,
            setIsWarningDialogOpen: setIsWarningDialogOpen
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                    label: ""
                }),
            "data-key": completeKey,
            testId: "createJiraIssueButton",
            onClick: (0, $2W2Mk.createJiraIssueSummaryHandle)(content.current, contentId, lastModifiedDate || lastModificationDate)
        }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-issue-issue-term-refresh",
            defaultMessage: "Create work item"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-issue",
            defaultMessage: "Create issue"
        }));
    };
    const createTrelloInboxButton = (completeKey)=>{
        if (!content.current || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oXkq.AddToTrelloInboxActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            contentId: contentId
        });
    };
    const createReadingAidsDefineButton = ({ selectedRange: selectedRange, selectedText: selectedText, isOverWordLimit: isOverWordLimit })=>{
        if (!content.current) return null;
        const isDisabled = isOverWordLimit && readingAidsChangeboardingStep === 'disabled' || // only check word limit when changeboarding is disabled
        readingAidsChangeboardingStep === 'spotlight'; // always disable when spotlight is active
        const commonDefineButtonProps = {
            testId: 'defineButton',
            isDisabled: isDisabled,
            onClick: ()=>{
                if (!selectedRange) return;
                if (!selectedText) return;
                if (isAIEnabledForContent || isRovoEnabledForContent) experienceTracker.start({
                    name: (0, $irVI7.READING_AIDS_EXPERIENCE),
                    attributes: {
                        contentId: contentId,
                        source: 'defineButton'
                    }
                });
                setDefineDefinitionOpen({
                    defineDefinitionOpen: true
                });
                setActionStates((prevState)=>({
                        ...prevState,
                        ...isOverWordLimit && readingAidsChangeboardingStep === 'idle' ? {
                            readingAidsChangeboardingStep: 'modal-word-count'
                        } : {
                            isReadingAidsOpen: true
                        },
                        show: false,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'defineButton',
                        type: 'ui',
                        attributes: {
                            contentId: contentId,
                            isAIOptedIn: isAIEnabledForContent
                        }
                    }
                }).fire();
            }
        };
        const oldDefineButtonIcon = isRovoEnabledForContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97kfW.AtlassianIntelligenceIcon), {
            size: "large",
            greyed: isDisabled
        });
        const defineButtonIcon = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: ""
        }) : oldDefineButtonIcon;
        const defineButtonContent = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.defineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
            ...commonDefineButtonProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                label: "",
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ...commonDefineButtonProps,
            appearance: "subtle",
            iconBefore: ()=>defineButtonIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        }));
        const defineButton = (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, defineButtonContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $cR1lV.READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID)
        }, defineButtonContent);
        return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.define.unsupported",
                defaultMessage: "Highlight a term, acronym, or abbreviation"
            }),
            component: (0, $9wGTI.fg)('confluence_comment_border_migration') ? $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated : $9755f908a54a6c5b$var$CustomLineWrapTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), defineButton)) : defineButton;
    };
    const handleClickChat = (0, $42omo.useCallback)(()=>{
        const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
        const isChatActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
        if (!isChatActive) rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const createRovoChatHighlightActionsButton = (selectedADFContent)=>{
        if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abUsF.RovoChatHighlightActions), {
            selectedContent: selectedADFContent,
            product: "confluence",
            onClickChat: handleClickChat
        });
    };
    const renderBuiltInWebItemActionsOld = (builtInWebItems, hasOtherActions)=>{
        const baseComponents = [];
        if (isRemixAvailable && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b5i6.RemixAction), {
            isNewToolbarEnabled: isNewToolbarEnabled,
            onClick: onRemixButtonPress,
            isDisabled: !onRemixButtonPress,
            isRemixInProgress: isRemixing,
            remixDisabledReason: remixDisabledReason
        }));
        if (hasInlineComments && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, null));
        if (snippetSlots?.button && (0, $6mKj3.expValEquals)('cc_snippets', 'isEnabled', true)) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "SnippetButton"
        }, snippetSlots.button));
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        if (isRovoEnabledForContent) {
            const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
            const selectedADFContent = (0, $eqKgz.htmlToADF)(selectionString);
            const itemToPush = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            baseComponents.push(itemToPush);
        } else if (showReadingAidsDefineButton) baseComponents.push(createReadingAidsDefineButton({
            selectedRange: selectedRange,
            selectedText: selectedText,
            isOverWordLimit: isOverWordLimit
        }));
        const builtInComponents = builtInWebItems.map((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') return createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') return createTrelloInboxButton(completeKey);
            return null;
        }).filter(Boolean);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsPatch), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents,
            ...isRemixAvailable && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b5i6.RemixAction), {
                    key: "RemixButton",
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    onClick: onRemixButtonPress,
                    isDisabled: !onRemixButtonPress,
                    isRemixInProgress: isRemixing,
                    remixDisabledReason: remixDisabledReason
                })
            ] : [],
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, {
                key: "CreateInlineCommentButton"
            }),
            ...(0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true) ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $erJgi.InlineReactionAction), {
                    key: "InlineReactionAction"
                })
            ] : []
        ], hasOtherActions));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsOld), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents,
            ...(0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true) ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $erJgi.InlineReactionAction), {
                    key: "InlineReactionAction"
                })
            ] : []
        ], hasOtherActions));
    };
    const renderBuiltInWebItemActions = (builtInWebItems, hasOtherActions)=>{
        const componentsAI = [];
        const components = [];
        const showMoreActions = [];
        let defineButton = null;
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
        const selectedADFContent = (0, $eqKgz.htmlToADF)(selectionString);
        if (isNewToolbarEnabled) {
            if (isRovoEnabledForContent) {
                const askRovoButton = createRovoChatHighlightActionsButton(selectedADFContent);
                if (askRovoButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(askRovoButton);
                    else components.push(askRovoButton);
                }
            }
            if (showReadingAidsDefineButton && !isOverWordLimit) {
                const defineButton = createReadingAidsDefineButton({
                    selectedRange: selectedRange,
                    selectedText: selectedText,
                    isOverWordLimit: isOverWordLimit
                });
                if (defineButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(defineButton);
                    else components.push(defineButton);
                }
            }
        } else {
            if (isRovoEnabledForContent) defineButton = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            else if (showReadingAidsDefineButton) defineButton = createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            if (defineButton) components.push(defineButton);
        }
        if (isRemixAvailable && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) {
            const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b5i6.RemixAction), {
                key: "RemixButton",
                isNewToolbarEnabled: isNewToolbarEnabled,
                onClick: onRemixButtonPress,
                isDisabled: !onRemixButtonPress,
                isRemixInProgress: isRemixing,
                remixDisabledReason: remixDisabledReason
            });
            if (isNewToolbarEnabled && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(remixButton);
            else components.push(remixButton);
        }
        const commentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, {
            key: "CreateInlineCommentButton"
        });
        components.push(commentButton);
        if ((0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true)) components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $erJgi.InlineReactionAction), {
            key: "InlineReactionAction"
        }));
        let jiraButton = null;
        let trelloButton = null;
        builtInWebItems.forEach((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') jiraButton = createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') trelloButton = createTrelloInboxButton(completeKey);
        });
        if (jiraButton) showMoreActions.push(jiraButton);
        if (trelloButton) showMoreActions.push(trelloButton);
        if (snippetSlots?.dropdownItem && (0, $6mKj3.expValEquals)('cc_snippets', 'isEnabled', true)) showMoreActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "SnippetDropdownItem"
        }, snippetSlots.dropdownItem));
        const _hasOtherActions = Boolean(hasOtherActions || showMoreActions.length > 0);
        if (isNewToolbarEnabled) {
            if (componentsAI.length > 0 && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) // if there are AI components, render them in a ToolbarSection with a separator at the end
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions-ai",
                    hasSeparator: (0, $48SU7.SeparatorPosition).END
                }, componentsAI), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions"
                }, components)),
                showMoreActions: showMoreActions
            };
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions"
                }, components),
                showMoreActions: showMoreActions
            };
        }
        return {
            builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                key: "built-in-actions",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _ca0q1b66 _n3td1b66 _19bv1b66",
                    !_hasOtherActions && "_u5f31b66"
                ])
            }, $9755f908a54a6c5b$export$c0b63e9f99a74f33(components, _hasOtherActions)),
            showMoreActions: showMoreActions
        };
    };
    const getComponentsForPopup = (webItems, forgeItems = [])=>{
        const webItemsWithTrello = (0, $9wGTI.fg)('quick_capture_trello_inbox') ? [
            ...webItems,
            {
                completeKey: 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
            }
        ] : webItems;
        const builtInWebItems = webItemsWithTrello.filter((item)=>$9755f908a54a6c5b$var$BUILT_IN_ITEMS.includes(item.completeKey));
        const connectItems = webItems.filter((item)=>!$9755f908a54a6c5b$export$9205c47465d0942.includes(item.completeKey));
        const hasOtherActions = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? Boolean(forgeItems?.length || connectItems?.length) : forgeItems?.length || connectItems?.length;
        const { builtInActions: builtInActions, showMoreActions: showMoreActions } = renderBuiltInWebItemActions(builtInWebItems, hasOtherActions);
        const otherActions = (0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        }));
        if (isNewToolbarEnabled) return [
            builtInActions,
            otherActions
        ];
        return [
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? builtInActions : renderBuiltInWebItemActionsOld(builtInWebItems, hasOtherActions),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
                key: "other-components",
                builtInActions: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? showMoreActions : undefined,
                connectItems: connectItems,
                forgeItems: forgeItems,
                selectForgeExtension: (forgeExtension)=>{
                    const selectedRange = (0, $2zMIV.getRange)();
                    if (!selectedRange) return;
                    const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                    if (!selectedText) return;
                    setActionStates((prevState)=>({
                            ...prevState,
                            forgeExtension: forgeExtension,
                            activeSelection: {
                                selectedText: selectedText,
                                selectedRange: selectedRange
                            }
                        }));
                }
            })
        ];
    };
    const renderPopup = (components)=>components.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, (bannerState)=>{
            // if there's a sticky header we want to position the toolbar below
            // the nav, the page header (if visible) and the sticky header
            let stickyHeaderHeight = 0;
            const range = (0, $2zMIV.getRange)();
            if (range) {
                const header = (0, $2zMIV.findStickyHeader)(range.commonAncestorContainer);
                if (header && bannerState) stickyHeaderHeight = bannerState.getTotalHeight() + header.clientHeight;
            }
            if (!screenEventFiredRef.current) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'highlightActionsMenu',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            screenEventFiredRef.current = true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEDve.Popup), {
                top: stickyHeaderHeight + (position?.top ?? top),
                left: position?.left ?? left,
                updatePosition: updatePosition
            }, components), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
            }));
        }) : null;
    const isCreateSingleJiraIssueHandleParams = (params)=>{
        return params?.fireAiAnalytics === undefined;
    };
    const handleConfirm = (0, $42omo.useCallback)(async ()=>{
        const callRightSidebarClose = async ()=>rightSidebarContext.close((0, $aiS08.ISSUE_CREATE_SIDE_PANEL_ID)); // Need to make sure sidebar is closed before creating a new one issue
        await callRightSidebarClose(); // Sorry this block sucks because of TS types
        if (isCreateSingleJiraIssueHandleParams(recordedClick)) (0, $joYQz.createSingleJiraIssueHandle)(recordedClick);
        else recordedClick && (0, $joYQz.createSingleAiJiraIssueHandle)(recordedClick);
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen,
        recordedClick,
        rightSidebarContext
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen
    ]);
    const contentSection = !isFabric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l4eiF.HighlightActionsContext).Provider, {
        value: highlightActionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        key: "content-container",
        ref: content
    }, children));
    const popupSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
        key: "action-panel",
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        fetchPolicy: "cache-first"
    }, ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
            render: (forgeItems, loading, error)=>{
                if (loading) return null;
                if (error) {
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                return renderPopup(getComponentsForPopup(webItems, forgeItems));
            }
        }))) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onConfirm: handleConfirm,
        onCancel: handleCancel
    }), contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), contentQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentQueryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        render: (_apps, _loading, error)=>{
            if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            return null;
        }
    }), forgeExtension && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9755f908a54a6c5b$var$ForgeAction, {
        content: content.current,
        contentId: contentId,
        forgeExtension: forgeExtension,
        activeSelection: activeSelection,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    forgeExtension: null
                }));
        }
    }), (0, $9wGTI.fg)('kd_definitions_confluence_enable_platform') ? isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9755f908a54a6c5b$var$DefinitionAction, {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        selectedText: activeSelection.selectedText,
        selectionRect: selectionRect
    }) : isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Jxlo.ReadingAidsPopup), {
        selectedText: activeSelection.selectedText,
        selectionRange: activeSelection.selectedRange,
        selectionRect: selectionRect,
        isReadingAidsOpen: isReadingAidsOpen,
        onClose: ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        contentId: contentId,
        popupPortalContainerId: (0, $bEdUx.popupPortalContainerId),
        onResult: (result)=>{
            if (readingAidsChangeboardingStep === 'idle') {
                if (result?.nlpSearch?.errorState?.startsWith('NO_ANSWER')) setActionStates((prevState)=>({
                        ...prevState,
                        isReadingAidsOpen: false,
                        readingAidsChangeboardingStep: 'modal-undefined'
                    }));
                else stopReadingAidsChangeboarding();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dvlB.default), null, readingAidsChangeboardingStep.startsWith('modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a3Fla.ReadingAidsChangeboardingModal), {
        onNextClick: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    readingAidsChangeboardingStep: 'spotlight',
                    show: true
                }));
        },
        modalVersion: readingAidsChangeboardingStep,
        contentId: contentId
    }) : null), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: readingAidsChangeboardingStep === 'spotlight',
        placement: "bottom-start",
        dismiss: ()=>void stopReadingAidsChangeboarding()
    }, readingAidsChangeboardingStep === 'spotlight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    })), contentSection, popupSection) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, readingAidsChangeboardingStep === 'spotlight' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    }) : null), contentSection, popupSection));
};
module.exports["DROPDOWN_EXCLUDED_ITEMS"] = $9755f908a54a6c5b$export$9205c47465d0942;
module.exports["HighlightActions"] = $9755f908a54a6c5b$export$a6299569dd2a354f;

});

parcelRegister("8dvlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce20a225af4b866c$export$2e2bcd8739ae039);
/**
 * We re-export this because products may have multiple versions of
 * `@atlaskit/modal-dialog`.
 *
 * If a consumer uses the onboarding `Modal` with the `ModalTransition` from an
 * incompatible version of `@atlaskit/modal-dialog`, then the modal can get
 * stuck in an open state.
 *
 * See https://product-fabric.atlassian.net/browse/DSP-796 for more details
 * and a reproduction.
 *
 */ 
var $6xdDU = parcelRequire("6xdDU");

var /**
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ $ce20a225af4b866c$export$2e2bcd8739ae039 = (0, $6xdDU.default);

});

parcelRegister("2A8CJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    lastModificationDate: null
});
$dae2c2bf6a5fe745$export$6d9b0a4fb48787a7.displayName = 'ContentBodyContext';
module.exports["ContentBodyContext"] = $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7;

});

parcelRegister("a3Fla", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $371bfa624b8f4825$export$d9088a53cb7c38b4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "W_5EK",
    name: "ReadingAidsChangeboardingModal",
    loader: async ()=>(await (parcelRequire("d7fiu"))).ReadingAidsChangeboardingModal
});
module.exports["ReadingAidsChangeboardingModal"] = $371bfa624b8f4825$export$d9088a53cb7c38b4;

});

parcelRegister("d7fiu", function(module, exports) {

let $98c7cb83b0c6308d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98c7cb83b0c6308d$var$load("6wr18"),
    $98c7cb83b0c6308d$var$load("ffEVr"),
    $98c7cb83b0c6308d$var$load("kwiXK")
]).then(()=>parcelRequire('iPt4B'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9ikgN", function(module, exports) {
$parcel$export(module.exports, "READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID", () => (parcelRequire("cR1lV")).READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID);

var $jmjWc = parcelRequire("jmjWc");


var $cR1lV = parcelRequire("cR1lV");


const $ade6da7539ba5902$export$1942ca99b3c33b66 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B2kdC",
    name: "ReadingAidsChangeboardingSpotlight",
    loader: async ()=>(await Promise.resolve((parcelRequire("cR1lV")))).ReadingAidsChangeboardingSpotlight
});
module.exports["ReadingAidsChangeboardingSpotlight"] = $ade6da7539ba5902$export$1942ca99b3c33b66;

});

parcelRegister("cR1lV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");

const $83df18abc582ef5a$export$a21884ebed08a664 = 'reading-aids-spotlight';
const $83df18abc582ef5a$var$i18n = (0, $aXWIB.defineMessages)({
    changeboardingSpotlightGotItButton: {
        id: "contextual-reading-aids.changeboarding-spotlight.got-it-button",
        defaultMessage: "Got it"
    },
    changeboardingSpotlightText: {
        id: "contextual-reading-aids.changeboarding-spotlight.text",
        defaultMessage: "Remember, this feature works best when you select specific terms, acronyms, or internal project/team names."
    }
});
const $83df18abc582ef5a$export$1942ca99b3c33b66 = ({ contentId: contentId, onGotItClick: onGotItClick })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'readingAidsSpotlightChangeboarding',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'readingAidsSpotlightGotItButton',
                attributes: {
                    contentId: contentId
                }
            }
        });
        onGotItClick();
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: [
            {
                text: intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightGotItButton),
                onClick: handleOnClick
            }
        ],
        target: $83df18abc582ef5a$export$a21884ebed08a664,
        targetRadius: 4
    }, intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightText));
};
module.exports["READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID"] = $83df18abc582ef5a$export$a21884ebed08a664;
module.exports["ReadingAidsChangeboardingSpotlight"] = $83df18abc582ef5a$export$1942ca99b3c33b66;

});

parcelRegister("erJgi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4FHTF = parcelRequire("4FHTF");


var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");

var $iIVVb = parcelRequire("iIVVb");


var $dklIa = parcelRequire("dklIa");

const $96891b810f2a7438$var$messages = (0, $aXWIB.defineMessages)({
    reactTooltip: {
        id: "experiment-inline-reactions.inline-reaction.tooltip",
        defaultMessage: "React"
    },
    reactLabel: {
        id: "experiment-inline-reactions.inline-reaction.label",
        defaultMessage: "React"
    }
});
const $96891b810f2a7438$export$9e9c4b5df2f723ad = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { triggerOpen: triggerOpen } = (0, $dklIa.useInlineReactionActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage($96891b810f2a7438$var$messages.reactTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-react",
        onClick: triggerOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $96891b810f2a7438$var$messages.reactLabel))));
};
module.exports["InlineReactionAction"] = $96891b810f2a7438$export$9e9c4b5df2f723ad;

});

parcelRegister("3b5i6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $jQW4q = parcelRequire("jQW4q");


var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");

var $iIVVb = parcelRequire("iIVVb");

const $62937d50f24b4234$var$messages = (0, $aXWIB.defineMessages)({
    remixInProgressTooltip: {
        id: "highlight-actions.remix-action.in-progress-tooltip",
        defaultMessage: "Remix in progress..."
    },
    remixToolbarTooltip: {
        id: "highlight-actions.remix-action.toolbar-tooltip",
        defaultMessage: "Remix"
    },
    remixToolbarLabel: {
        id: "highlight-actions.remix-action.toolbar-label",
        defaultMessage: "Remix"
    },
    remixDisabledTooltipArchived: {
        id: "highlight-actions.remix-action.disabled-tooltip-archived",
        defaultMessage: "Content on archived pages can't be remixed"
    },
    remixDisabledTooltipVersionHistory: {
        id: "highlight-actions.remix-action.disabled-tooltip-version-history",
        defaultMessage: "Remix is unavailable in version history"
    }
});
const $62937d50f24b4234$var$getRemixDisabledTooltip = (formatMessage, reason)=>{
    switch(reason){
        case 'version-history':
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipArchived);
    }
};
const $62937d50f24b4234$export$750386901eee7bd0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { isNewToolbarEnabled: isNewToolbarEnabled, onClick: onClick, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== isDisabled || $[2] !== isRemixInProgress || $[3] !== remixDisabledReason) {
        t1 = isRemixInProgress ? formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip) : isDisabled ? $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason) : formatMessage($62937d50f24b4234$var$messages.remixToolbarTooltip);
        $[0] = formatMessage;
        $[1] = isDisabled;
        $[2] = isRemixInProgress;
        $[3] = remixDisabledReason;
        $[4] = t1;
    } else t1 = $[4];
    const tooltipContent = t1;
    let t2;
    if ($[5] !== isDisabled || $[6] !== isNewToolbarEnabled || $[7] !== isRemixInProgress || $[8] !== onClick || $[9] !== tooltipContent) {
        t2 = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
                label: "",
                size: "small"
            }),
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: isDisabled || isRemixInProgress
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: isDisabled || isRemixInProgress
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)));
        $[5] = isDisabled;
        $[6] = isNewToolbarEnabled;
        $[7] = isRemixInProgress;
        $[8] = onClick;
        $[9] = tooltipContent;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ isNewToolbarEnabled: isNewToolbarEnabled, onClick: onClick, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const tooltipContent = isRemixInProgress ? formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip) : isDisabled ? $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason) : formatMessage($62937d50f24b4234$var$messages.remixToolbarTooltip);
    return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)));
};
module.exports["RemixAction"] = $62937d50f24b4234$export$750386901eee7bd0;

});

parcelRegister("6W81y", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dAYOx = parcelRequire("dAYOx");


var $g5gZt = parcelRequire("g5gZt");


var $2qVkt = parcelRequire("2qVkt");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $inPa6 = parcelRequire("inPa6");


var $1pSma = parcelRequire("1pSma");


var $iu6m9 = parcelRequire("iu6m9");


var $2GVu1 = parcelRequire("2GVu1");






var $fYQcF = parcelRequire("fYQcF");


var $jln20 = parcelRequire("jln20");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $frJep = parcelRequire("frJep");


var $cSSgB = parcelRequire("cSSgB");


var $ai7NK = parcelRequire("ai7NK");


var $9wGTI = parcelRequire("9wGTI");


var $cAdj8 = parcelRequire("cAdj8");


var $1xpoY = parcelRequire("1xpoY");


var $6mKj3 = parcelRequire("6mKj3");


var $2W2Mk = parcelRequire("2W2Mk");


var $joYQz = parcelRequire("joYQz");

const $ae4b6329110effd0$export$67bda1dbd5f0074c = {
    SINGLE_ISSUE: 'SINGLE_ISSUE',
    MULTIPLE_ISSUE: 'MULTIPLE_ISSUE',
    AI_ISSUE: 'AI_ISSUE'
};
// Helper function to find the parent <table> element of a given node
const $ae4b6329110effd0$var$findParentTable = (node)=>{
    let currentNode = node;
    while(currentNode){
        if (currentNode.nodeType === Node.ELEMENT_NODE && currentNode.tagName === 'TABLE') return currentNode;
        currentNode = currentNode.parentNode;
    }
    return null;
};
// Use this helper function when we have the modernized bulk create ready.
const $ae4b6329110effd0$var$isMultiRowTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Helper function to find the parent <tr> element of a given node
    const findParentTableRow = (node)=>{
        while(node){
            if (node.tagName === 'TR') return node;
            node = node.parentNode;
        }
        return null;
    };
    // Find the closest <tr> ancestor for both start and end of the selection
    const startRow = findParentTableRow(startContainer);
    const endRow = findParentTableRow(endContainer);
    if (!startRow || !endRow) return false;
    // If the start and end are not in the same row, it's a multi-row selection
    return startRow !== endRow;
};
/**
 * isTableSelection: returns true if the user highlights over only
 * table content.
 * @param selection
 * @returns {boolean}
 */ const $ae4b6329110effd0$var$isTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Check if both the start and end container are within a table
    const startInTable = $ae4b6329110effd0$var$findParentTable(startContainer) !== null;
    const endInTable = $ae4b6329110effd0$var$findParentTable(endContainer) !== null;
    return startInTable && endInTable;
};
const $ae4b6329110effd0$export$50d84a2be082120 = (selection)=>{
    if (!selection || selection.rangeCount === 0) return 0;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return 0;
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    const startInActionContainer = (0, $cSSgB.findActionItemElement)(startContainer);
    const endInActionContainer = (0, $cSSgB.findActionItemElement)(endContainer);
    let commonAncestor;
    if (startInActionContainer || endInActionContainer) {
        const actionItemRange = range.cloneRange();
        actionItemRange.setStart(startInActionContainer || startContainer, 0);
        actionItemRange.setEnd(endInActionContainer || endContainer, 0);
        commonAncestor = actionItemRange.commonAncestorContainer;
    } else // the selection might span across different containers
    // or be in between the start and end highlight
    commonAncestor = range.commonAncestorContainer;
    const walker = document.createTreeWalker(commonAncestor, NodeFilter.SHOW_ELEMENT, null);
    let node = walker.currentNode;
    let actionItemsInSelection = 0;
    while(node){
        if (range.intersectsNode(node)) {
            const element = node;
            if (element.dataset?.taskLocalId !== undefined) actionItemsInSelection++;
        }
        node = walker.nextNode();
    }
    return actionItemsInSelection;
};
const $ae4b6329110effd0$var$getIssueCreationType = ({ isAIIssueCreationEnabled: isAIIssueCreationEnabled })=>{
    if (isAIIssueCreationEnabled) return $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE;
    else return $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE;
};
const $ae4b6329110effd0$var$userHasEditPermission = (pageInfo)=>{
    if (!pageInfo) return false;
    const contentType = pageInfo.type;
    return pageInfo.operations?.some((op)=>op?.operation === 'update' && op?.targetType === contentType) || false;
};
const $ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows } = t0;
    let t1;
    let t2;
    if ($[0] !== completeKey || $[1] !== handleCreateIssueItemClicked || $[2] !== isAIIssueCreationEnabled || $[3] !== isSelectionMultipleRows) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
                isAIIssueCreationEnabled: isAIIssueCreationEnabled
            });
            const getIcon = (iconProps)=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                    ...iconProps,
                    label: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
                    ...iconProps,
                    label: ""
                });
            };
            const getIconAIFC = (iconProps_0)=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                    ...iconProps_0,
                    size: "small",
                    label: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
                    ...iconProps_0,
                    size: "small",
                    label: ""
                });
            };
            const getButtonText = ()=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    id: "highlight-actions.create-multiple-jira-work-items",
                    defaultMessage: "Create Jira work items"
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    id: "highlight-actions.create-jira-work-item",
                    defaultMessage: "Create Jira work item"
                });
            };
            if ((0, $9wGTI.fg)("aifc_create_enabled") || (0, $6mKj3.expValEquals)("platform_editor_toolbar_aifc_confluence", "isEnabled", true)) {
                let t3;
                if ($[6] !== getIconAIFC) {
                    t3 = getIconAIFC({});
                    $[6] = getIconAIFC;
                    $[7] = t3;
                } else t3 = $[7];
                const t4 = handleCreateIssueItemClicked(issueCreationType);
                let t5;
                if ($[8] !== getButtonText) {
                    t5 = getButtonText();
                    $[8] = getButtonText;
                    $[9] = t5;
                } else t5 = $[9];
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
                    testId: "consolidated-create-jira-issue-button",
                    "data-key": completeKey,
                    shouldTitleWrap: false,
                    elemBefore: t3,
                    onClick: t4
                }, t5);
                break bb0;
            }
            t1 = (0, $iu6m9.editorExperiment)("platform_editor_controls", "variant1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                testId: "consolidated-create-jira-issue-button",
                "data-key": completeKey,
                shouldTitleWrap: false,
                elemBefore: getIcon({}),
                onClick: handleCreateIssueItemClicked(issueCreationType)
            }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                id: "create-jira-issue-button",
                appearance: "subtle",
                iconBefore: $ae4b6329110effd0$var$_temp,
                "data-key": completeKey,
                testId: "consolidated-create-jira-issue-button",
                onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? "MULTIPLE_ISSUE" : $ae4b6329110effd0$var$getIssueCreationType({
                    isAIIssueCreationEnabled: isAIIssueCreationEnabled
                })),
                spacing: "compact"
            }, (0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.create-jira-issue-issue-term-refresh",
                defaultMessage: "Jira work item"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.create-jira-issue",
                defaultMessage: "Jira issue"
            }));
        }
        $[0] = completeKey;
        $[1] = handleCreateIssueItemClicked;
        $[2] = isAIIssueCreationEnabled;
        $[3] = isSelectionMultipleRows;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    return t1;
} : ({ completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows })=>{
    const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
        isAIIssueCreationEnabled: isAIIssueCreationEnabled
    });
    const getIcon = (iconProps)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            ...iconProps,
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
            ...iconProps,
            label: ""
        });
    };
    const getIconAIFC = (iconProps_0)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            ...iconProps_0,
            size: "small",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
            ...iconProps_0,
            size: "small",
            label: ""
        });
    };
    const getButtonText = ()=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-multiple-jira-work-items",
            defaultMessage: "Create Jira work items"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-jira-work-item",
            defaultMessage: "Create Jira work item"
        });
    };
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIconAIFC({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText());
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIcon({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "create-jira-issue-button",
        appearance: "subtle",
        iconBefore: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                ...iconProps_1,
                label: ""
            }),
        "data-key": completeKey,
        testId: "consolidated-create-jira-issue-button",
        onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? 'MULTIPLE_ISSUE' : $ae4b6329110effd0$var$getIssueCreationType({
            isAIIssueCreationEnabled: isAIIssueCreationEnabled
        })),
        spacing: "compact"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.create-jira-issue-issue-term-refresh",
        defaultMessage: "Jira work item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.create-jira-issue",
        defaultMessage: "Jira issue"
    }));
};
const $ae4b6329110effd0$export$f91cf3aef874f6f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen } = t0;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1pSma.default)("highlight-actions.ai-issue-create.dropdown-item-click");
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    let t1;
    if ($[0] !== activeSelection) {
        t1 = $ae4b6329110effd0$var$isTableSelection(activeSelection);
        $[0] = activeSelection;
        $[1] = t1;
    } else t1 = $[1];
    const isSelectionInTable = t1;
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    let t2;
    if ($[2] !== actionItemsInSelection || $[3] !== isSelectionInTable) {
        t2 = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)("confluence-create-work-items-from-action-items");
        $[2] = actionItemsInSelection;
        $[3] = isSelectionInTable;
        $[4] = t2;
    } else t2 = $[4];
    const isActionItemInSelection = t2;
    let t3;
    if ($[5] !== actionItemsInSelection || $[6] !== isSelectionInTable) {
        t3 = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)("confluence-create-work-items-from-action-items");
        $[5] = actionItemsInSelection;
        $[6] = isSelectionInTable;
        $[7] = t3;
    } else t3 = $[7];
    const isMultiActionItemsInSelection = t3;
    let t4;
    if ($[8] !== activeSelection || $[9] !== isMultiActionItemsInSelection) {
        t4 = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
        $[8] = activeSelection;
        $[9] = isMultiActionItemsInSelection;
        $[10] = t4;
    } else t4 = $[10];
    const isSelectionMultipleRows = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            fetchPolicy: "cache-first"
        };
        $[11] = t5;
    } else t5 = $[11];
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)(t5);
    let t6;
    if ($[12] !== pageInfo) {
        t6 = $ae4b6329110effd0$var$userHasEditPermission(pageInfo);
        $[12] = pageInfo;
        $[13] = t6;
    } else t6 = $[13];
    const hasEditPermission = t6;
    let t7;
    if ($[14] !== createAnalyticsEvent || $[15] !== hasEditPermission) {
        t7 = (issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluenceHighlightActionsMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "jiraIssueLink",
                    type: "ui",
                    attributes: {
                        issueCreationType: issueCreationType,
                        isDropdownItem: false,
                        isCreatedFromTable: isCreatedFromTable,
                        isCreatedFromActionItems: isCreatedFromActionItems,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }
                }
            }).fire();
        };
        $[14] = createAnalyticsEvent;
        $[15] = hasEditPermission;
        $[16] = t7;
    } else t7 = $[16];
    const fireCreateIssueButtonClickedAnalytics = t7;
    let t8;
    if ($[17] !== actions || $[18] !== activeSelection || $[19] !== container || $[20] !== contentId || $[21] !== contentType || $[22] !== fireCreateIssueButtonClickedAnalytics || $[23] !== hasEditPermission || $[24] !== isActionItemInSelection || $[25] !== isSelectionInTable || $[26] !== isSidePanelOpen || $[27] !== lastModified || $[28] !== pressTracing || $[29] !== rightSidebarContext || $[30] !== setIsCreatedFromActionItems || $[31] !== setIsCreatedFromTable || $[32] !== setIsCreatedWithAi || $[33] !== setIsWarningDialogOpen || $[34] !== setRecordedClick || $[35] !== trackAIInteractionInit) {
        t8 = (issueCreationType_0)=>()=>{
                if (!isSidePanelOpen) bb29: switch(issueCreationType_0){
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $joYQz.createSingleJiraIssueHandle)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            isActionItemInSelection: isActionItemInSelection,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        });
                        break bb29;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        !(0, $1xpoY.default).getBoolean("confluence_legacy_bulk_jira_work_create", false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                            rightSidebarContext: rightSidebarContext,
                            pressTracing: pressTracing,
                            activeSelection: activeSelection,
                            actions: actions,
                            setIsCreatedWithAi: setIsCreatedWithAi,
                            setIsCreatedFromTable: setIsCreatedFromTable,
                            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                            contentId: contentId,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                        break bb29;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $joYQz.createSingleAiJiraIssueHandle)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            fireAiAnalytics: trackAIInteractionInit,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW,
                            isActionItemInSelection: isActionItemInSelection
                        });
                        pressTracing();
                }
                else {
                    const aiData = {
                        contentType: contentType,
                        fireAiAnalytics: trackAIInteractionInit
                    };
                    const tempData = {
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                    };
                    setRecordedClick(tempData);
                    setIsWarningDialogOpen(true);
                }
            };
        $[17] = actions;
        $[18] = activeSelection;
        $[19] = container;
        $[20] = contentId;
        $[21] = contentType;
        $[22] = fireCreateIssueButtonClickedAnalytics;
        $[23] = hasEditPermission;
        $[24] = isActionItemInSelection;
        $[25] = isSelectionInTable;
        $[26] = isSidePanelOpen;
        $[27] = lastModified;
        $[28] = pressTracing;
        $[29] = rightSidebarContext;
        $[30] = setIsCreatedFromActionItems;
        $[31] = setIsCreatedFromTable;
        $[32] = setIsCreatedWithAi;
        $[33] = setIsWarningDialogOpen;
        $[34] = setRecordedClick;
        $[35] = trackAIInteractionInit;
        $[36] = t8;
    } else t8 = $[36];
    const handleCreateIssueItemClicked = t8;
    let t9;
    if ($[37] !== completeKey || $[38] !== handleCreateIssueItemClicked || $[39] !== isAIIssueCreationEnabled || $[40] !== isSelectionMultipleRows) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
            completeKey: completeKey,
            handleCreateIssueItemClicked: handleCreateIssueItemClicked,
            isAIIssueCreationEnabled: isAIIssueCreationEnabled,
            isSelectionMultipleRows: isSelectionMultipleRows
        });
        $[37] = completeKey;
        $[38] = handleCreateIssueItemClicked;
        $[39] = isAIIssueCreationEnabled;
        $[40] = isSelectionMultipleRows;
        $[41] = t9;
    } else t9 = $[41];
    return t9;
} : ({ activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen })=>{
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1pSma.default)('highlight-actions.ai-issue-create.dropdown-item-click');
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    const isSelectionInTable = $ae4b6329110effd0$var$isTableSelection(activeSelection);
    // table creation has higher priority than action item creation
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    const isActionItemInSelection = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isMultiActionItemsInSelection = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isSelectionMultipleRows = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $42omo.useMemo)(()=>$ae4b6329110effd0$var$userHasEditPermission(pageInfo), [
        pageInfo
    ]);
    const fireCreateIssueButtonClickedAnalytics = (0, $42omo.useCallback)((issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: issueCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    hasEditPermission: hasEditPermission,
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasEditPermission
    ]);
    const handleCreateIssueItemClicked = (0, $42omo.useCallback)((issueCreationType_0)=>()=>{
            if (!isSidePanelOpen) switch(issueCreationType_0){
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        isActionItemInSelection: isActionItemInSelection,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    });
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    !(0, $1xpoY.default).getBoolean('confluence_legacy_bulk_jira_work_create', false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                        rightSidebarContext: rightSidebarContext,
                        pressTracing: pressTracing,
                        activeSelection: activeSelection,
                        actions: actions,
                        setIsCreatedWithAi: setIsCreatedWithAi,
                        setIsCreatedFromTable: setIsCreatedFromTable,
                        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleAiJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        fireAiAnalytics: trackAIInteractionInit,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW,
                        isActionItemInSelection: isActionItemInSelection
                    });
                    pressTracing();
                    break;
            }
            else {
                // ai specific data
                const aiData = {
                    contentType: contentType,
                    fireAiAnalytics: trackAIInteractionInit
                };
                // record temp data
                const tempData = {
                    rightSidebarContext: rightSidebarContext,
                    actions: actions,
                    activeSelection: activeSelection,
                    contentId: contentId,
                    container: container,
                    lastModified: lastModified,
                    hasEditPermission: hasEditPermission,
                    ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                };
                setRecordedClick(tempData);
                setIsWarningDialogOpen(true);
            }
        }, [
        isSidePanelOpen,
        fireCreateIssueButtonClickedAnalytics,
        isSelectionInTable,
        rightSidebarContext,
        actions,
        activeSelection,
        contentId,
        contentType,
        container,
        lastModified,
        pressTracing,
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        trackAIInteractionInit,
        setRecordedClick,
        setIsWarningDialogOpen,
        hasEditPermission,
        isActionItemInSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
        completeKey: completeKey,
        handleCreateIssueItemClicked: handleCreateIssueItemClicked,
        isAIIssueCreationEnabled: isAIIssueCreationEnabled,
        isSelectionMultipleRows: isSelectionMultipleRows
    });
};
function $ae4b6329110effd0$var$_temp(iconProps_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        ...iconProps_1,
        label: ""
    });
}
module.exports["CreateJiraIssueActions"] = $ae4b6329110effd0$export$f91cf3aef874f6f;

});

parcelRegister("frJep", function(module, exports) {

var $1mDVg = parcelRequire("1mDVg");


var $dAg4H = parcelRequire("dAg4H");


var $2ay9q = parcelRequire("2ay9q");

const $ae678835b2293c93$export$58de3335a79e10d3 = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
    const isCreateIssueWithAiEnabledByUser = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)();
    return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
module.exports["useIsAIIssueCreationEnabled"] = $ae678835b2293c93$export$58de3335a79e10d3;

});

parcelRegister("2W2Mk", function(module, exports) {

var $04e9M = parcelRequire("04e9M");


var $aUTn5 = parcelRequire("aUTn5");

const $fc9c79783a6d919a$export$b5c53601259f278e = (container, contentId, lastModified)=>()=>{
        const selection = window.getSelection();
        if (selection) {
            // Send an event to track the user clicking the JIRA Link
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendUIEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'jiraIssueLink',
                    source: 'HighlightContextMenu'
                });
            });
            window.dispatchEvent(new CustomEvent('create-jira-issue-summary', // Convert window.getSelection() to legacy format used in jira issue summary.
            // Once we Reactified it this should be deleted.
            {
                detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
            }));
        }
    };
const $fc9c79783a6d919a$export$92ec81e7ac5e7973 = (container, contentId, lastModified)=>{
    const selection = window.getSelection();
    if (selection) {
        window.dispatchEvent(new CustomEvent('create-jira-issue-summary', {
            detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
        }));
        const observer = new MutationObserver((_mutations, observer)=>{
            const createMultipleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-multiple-issues');
            if (createMultipleButton) {
                createMultipleButton.click();
                observer.disconnect();
            }
            const createSingleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-single-issue');
            if (createSingleButton) createSingleButton.style.display = 'none';
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};
module.exports["createJiraIssueSummaryHandle"] = $fc9c79783a6d919a$export$b5c53601259f278e;
module.exports["createMultipleJiraIssuesHandle"] = $fc9c79783a6d919a$export$92ec81e7ac5e7973;

});

parcelRegister("joYQz", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3TWPv = parcelRequire("3TWPv");


var $cSSgB = parcelRequire("cSSgB");


var $euVTc = parcelRequire("euVTc");


var $1Q0l6 = parcelRequire("1Q0l6");


var $2ViZo = parcelRequire("2ViZo");


var $UNr39 = parcelRequire("UNr39");


var $aUTn5 = parcelRequire("aUTn5");

const $4d90dab75b68bf7b$export$a25c0fd63a5cc834 = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $4d90dab75b68bf7b$export$233a92718b28d19e = 254;
const $4d90dab75b68bf7b$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    // Calculate the length of the first part without including the ellipsis
    const firstPartLength = maxLength - horizontalEllipsis.length;
    // Split the text into two parts
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $4d90dab75b68bf7b$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $4d90dab75b68bf7b$export$a25c0fd63a5cc834(activeSelection);
    const [summary] = $4d90dab75b68bf7b$export$2878cc467c8be8fe(selectionString, $4d90dab75b68bf7b$export$233a92718b28d19e);
    /*
   The regex matches one or more occurrences of any line break (\r, \n) or tab (\t)
   and replaces them all with a single space. (We only consider whitespace characters because
   these are the only ones that ultimately stick when parsing the summary.)
   */ const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    // Convert the full HTML content to ADF for the description
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $4d90dab75b68bf7b$export$358d16442308a1f3 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    actions.setIsCreatedWithAi(false);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
};
const $4d90dab75b68bf7b$export$5378c6b60bde04bf = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, fireAiAnalytics: fireAiAnalytics, lastModified: lastModified, pressTracing: pressTracing, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    fireAiAnalytics();
    actions.setIsCreatedWithAi(true);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
    pressTracing?.();
};
const $4d90dab75b68bf7b$export$83a48a684a9c82ca = ({ actions: actions, setIsCreatedWithAi: setIsCreatedWithAi, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, rightSidebarContext: rightSidebarContext, pressTracing: pressTracing, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode })=>{
    if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) {
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            pageMode: pageMode,
            hasEditPermission: hasEditPermission,
            container: container,
            lastModified: lastModified,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        if (result === (0, $2ViZo.BulkSelectionResult).None) return;
    } else {
        const selectedActionList = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageMode);
        const selectedTable = (0, $euVTc.getClosestTableFromSelection)(activeSelection);
        if (!selectedTable && !selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) // We have checks to ensure that the activeSelection is in a table or contains action items, so this should never happen.
        return;
        if (selectedTable) {
            actions.setSelectedTable(selectedTable);
            const insertStorageColumnTableRequestPayload = (0, $1Q0l6.constructInsertStorageColumnTableRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
            actions.setInsertStorageColumnTableRequestPayload(insertStorageColumnTableRequestPayload);
            setIsCreatedFromTable(true);
            $4d90dab75b68bf7b$var$resetActionItemsState(setIsCreatedFromActionItems, actions);
        } else if (selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
            actions.setSelectedActionItems(selectedActionList);
            const actionItems = selectedActionList.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])');
            const ranges = [];
            actionItems.forEach((actionItem)=>{
                const range = new Range();
                range.selectNodeContents(actionItem);
                const validRange = (0, $1Q0l6.getValidRangeForActionItem)(range);
                if (validRange) ranges.push(validRange);
            });
            const insertMultipleStorageFragmentsRequestPayload = (0, $1Q0l6.constructInsertMultipleStorageFragmentsRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), ranges, container, lastModified);
            actions.setInsertMultipleStorageFragmentsRequestPayload(insertMultipleStorageFragmentsRequestPayload);
            setIsCreatedFromActionItems(true);
            $4d90dab75b68bf7b$var$resetTableState(setIsCreatedFromTable, actions);
        }
        actions.setContentId(contentId);
        actions.setPageMode(pageMode);
        actions.setHasEditPermission(hasEditPermission);
        setIsCreatedWithAi(false);
    }
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    pressTracing?.();
};
const $4d90dab75b68bf7b$var$resetTableState = (setIsCreatedFromTable, actions)=>{
    setIsCreatedFromTable(false);
    actions.setSelectedTable(undefined);
    actions.setInsertStorageColumnTableRequestPayload(undefined);
};
const $4d90dab75b68bf7b$var$resetActionItemsState = (setIsCreatedFromActionItems, actions)=>{
    setIsCreatedFromActionItems(false);
    actions.setSelectedActionItems(undefined);
    actions.setInsertMultipleStorageFragmentsRequestPayload(undefined);
};
module.exports["getHTMLString"] = $4d90dab75b68bf7b$export$a25c0fd63a5cc834;
module.exports["createSingleJiraIssueHandle"] = $4d90dab75b68bf7b$export$358d16442308a1f3;
module.exports["createSingleAiJiraIssueHandle"] = $4d90dab75b68bf7b$export$5378c6b60bde04bf;
module.exports["createMultipleJiraIssuesHandleModernized"] = $4d90dab75b68bf7b$export$83a48a684a9c82ca;

});

parcelRegister("3TWPv", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $9wGTI = parcelRequire("9wGTI");


var $1Q0l6 = parcelRequire("1Q0l6");


var $1mDVg = parcelRequire("1mDVg");


var $1L1jV = parcelRequire("1L1jV");


var $cSSgB = parcelRequire("cSSgB");


var $9uzSK = parcelRequire("9uzSK");

const $918fba8df3fbcc13$export$233a92718b28d19e = 254;
const $918fba8df3fbcc13$var$getHTMLString = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $918fba8df3fbcc13$export$db5a8500f6b6286e = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipsis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipsis,
        text
    ];
};
const $918fba8df3fbcc13$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $918fba8df3fbcc13$var$getHTMLString(activeSelection);
    const [summary] = $918fba8df3fbcc13$export$db5a8500f6b6286e(selectionString, $918fba8df3fbcc13$export$233a92718b28d19e);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $918fba8df3fbcc13$export$41bb5569f66eae2a = ({ actions: actions, rightSidebarContext: rightSidebarContext, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const { updatedSelection: updatedSelection, activeSelectionRange: activeSelectionRange } = $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected({
        activeSelection: activeSelection,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    const shouldUseSelectionAdf = pageMode !== (0, $1mDVg.PageMode).VIEW && !!selectionAdfResult?.selectedNodeAdf;
    const selectionAdf = shouldUseSelectionAdf ? (0, $9uzSK.extractSelectedAdfSlice)(selectionAdfResult) : undefined;
    const highlightedText = shouldUseSelectionAdf ? (0, $9uzSK.normalizeToDocNode)(selectionAdf) : (0, $eqKgz.htmlToADF)($918fba8df3fbcc13$var$getHTMLString(updatedSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, convertSelectionToLegacyFormat, activeSelectionRange, container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = shouldUseSelectionAdf ? (0, $9uzSK.getSummaryAndDescriptionFromSelectionAdfResult)(selectionAdfResult, $918fba8df3fbcc13$export$233a92718b28d19e) : $918fba8df3fbcc13$export$5645fd1d37220db2(updatedSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    actions.setPageMode(pageMode);
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected = ({ activeSelection: activeSelection, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    let updatedSelection = activeSelection;
    let activeSelectionRange = (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0));
    if (isActionItemInSelection && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
        const updatedActiveSelection = (0, $cSSgB.includeEntireActionItemInSelection)(activeSelection, pageMode);
        if (updatedActiveSelection instanceof Range) {
            updatedSelection = updatedActiveSelection;
            activeSelectionRange = (0, $1Q0l6.getValidRangeForActionItem)(updatedActiveSelection);
        } else activeSelectionRange = activeSelection && 'getRangeAt' in activeSelection ? (0, $1Q0l6.getValidRange)(activeSelection.getRangeAt(0)) : undefined;
    }
    return {
        updatedSelection: updatedSelection,
        activeSelectionRange: activeSelectionRange
    };
};
module.exports["openSingleIssueSidePanelWithSelection"] = $918fba8df3fbcc13$export$41bb5569f66eae2a;

});

parcelRegister("4oXkq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dAYOx = parcelRequire("dAYOx");


var $inPa6 = parcelRequire("inPa6");


var $iu6m9 = parcelRequire("iu6m9");


var $2GVu1 = parcelRequire("2GVu1");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $lpGuF = parcelRequire("lpGuF");


var $dMbwP = parcelRequire("dMbwP");


var $9ujb2 = parcelRequire("9ujb2");

const $ed7cf63fc877d47c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $ed7cf63fc877d47c$var$getHighlightedText = (selection)=>{
    if (!selection || selection.rangeCount === 0) return '';
    return selection.toString().trim();
};
const $ed7cf63fc877d47c$var$i18n = (0, $aXWIB.defineMessages)({
    trelloLabel: {
        id: "highlight-actions.create-trello-card",
        defaultMessage: "Send to your Trello Inbox"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});
const $ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent = ({ activeSelection: activeSelection, completeKey: completeKey, contentId: contentId, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const { hasTrelloAccess: hasTrelloAccess, loading: trelloAccessLoading } = (0, $9ujb2.useTrelloAccess)();
    const fireTrelloCardCreatedAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'trelloInboxCard',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    hasSelection: Boolean(activeSelection && activeSelection.toString().trim())
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        activeSelection
    ]);
    const showCreateErrorFlag = (0, $42omo.useCallback)(()=>{
        flags.showFlag({
            id: 'trello-inbox-create-error',
            type: 'error',
            title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.errorTitle),
            close: 'auto'
        });
    }, [
        flags,
        intl
    ]);
    const makeHandleCreateTrelloCardClick = (0, $42omo.useCallback)(async ()=>{
        const highlightedText = $ed7cf63fc877d47c$var$getHighlightedText(activeSelection);
        if (!highlightedText) return;
        try {
            fireTrelloCardCreatedAnalytics();
            const result = await (0, $lpGuF.createTrelloCardHandle)({
                text: highlightedText,
                contentId: contentId
            });
            if (result && result.success) {
                const actions = result.cardUrl ? [
                    {
                        content: intl.formatMessage($ed7cf63fc877d47c$var$i18n.openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ] : undefined;
                flags.showFlag({
                    id: 'trello-inbox-create-success',
                    type: 'success-circle',
                    title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.successTitle),
                    actions: actions,
                    close: 'auto'
                });
            } else showCreateErrorFlag();
        } catch  {
            $ed7cf63fc877d47c$var$logger.error`Error creating Trello card for contentId=${contentId}`;
            showCreateErrorFlag();
        }
    }, [
        activeSelection,
        contentId,
        fireTrelloCardCreatedAnalytics,
        flags,
        showCreateErrorFlag,
        intl
    ]);
    if (!(0, $9wGTI.fg)('quick_capture_trello_inbox')) return null;
    if (trelloAccessLoading) return null;
    if (!hasTrelloAccess) return null;
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "create-trello-card-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
            size: "small"
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "create-trello-card-button",
        "aria-label": intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        "data-key": completeKey,
        shouldTitleWrap: false,
        title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "create-trello-card-button",
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMbwP.TrelloInboxIcon), {
                label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)
            }),
        "data-key": completeKey,
        testId: "create-trello-card-button",
        onClick: makeHandleCreateTrelloCardClick,
        spacing: "compact"
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
};
const $ed7cf63fc877d47c$export$12f6e4d1b0812953 = (0, $7aRa9.withFlags)($ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent);
module.exports["AddToTrelloInboxActions"] = $ed7cf63fc877d47c$export$12f6e4d1b0812953;

});

parcelRegister("lpGuF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $988c838c2543c991$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT = '/wiki/api/v2/trello/inbox/card';
const $988c838c2543c991$var$CARD_NAME_MAX_LENGTH = 254;
const $988c838c2543c991$var$HORIZONTAL_ELLIPSIS = "\u2026";
const $988c838c2543c991$var$toPayloadSafeName = (raw, maxLength = $988c838c2543c991$var$CARD_NAME_MAX_LENGTH)=>{
    const normalized = String(raw).replace(/[\r\n\t]+/g, ' ').trim();
    if (normalized.length <= maxLength) return normalized;
    const firstPartLength = Math.max(0, maxLength - $988c838c2543c991$var$HORIZONTAL_ELLIPSIS.length);
    return normalized.substring(0, firstPartLength) + $988c838c2543c991$var$HORIZONTAL_ELLIPSIS;
};
const $988c838c2543c991$export$750e0c983aee1f51 = async ({ text: text, contentId: contentId })=>{
    const payload = {
        name: $988c838c2543c991$var$toPayloadSafeName(text, $988c838c2543c991$var$CARD_NAME_MAX_LENGTH),
        description: text || 'Created via Confluence',
        sourceContentId: contentId,
        sourceUrl: typeof location !== 'undefined' ? location.href : undefined
    };
    try {
        const resp = await fetch($988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) {
            $988c838c2543c991$var$logger.error`Failed to create Trello card for contentId=${contentId} status=${resp.status}`;
            return null;
        }
        const data = await resp.json();
        const idCandidate = data.cardId;
        const urlCandidate = data.cardUrl;
        if (!idCandidate || !urlCandidate) {
            $988c838c2543c991$var$logger.error`Invalid Trello response for contentId=${contentId}`;
            return null;
        }
        const response = {
            cardId: idCandidate || '',
            cardUrl: urlCandidate || '',
            success: true
        };
        return response;
    } catch  {
        $988c838c2543c991$var$logger.error`Error creating Trello card for contentId=${contentId}`;
        return null;
    }
};
module.exports["createTrelloCardHandle"] = $988c838c2543c991$export$750e0c983aee1f51;

});

parcelRegister("dMbwP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $flZlQ = parcelRequire("flZlQ");

const $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $flZlQ.default), {
            name: "TrelloInboxIcon",
            dangerouslySetGlyph: "<path fill=\"currentcolor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z\"/>",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $flZlQ.default), {
        name: "TrelloInboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" clip-rule="evenodd" d="M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z"/>`,
        ...props
    });
module.exports["TrelloInboxIcon"] = $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7;

});

parcelRegister("9ujb2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7W8i8 = parcelRequire("7W8i8");

const $26b2f47c8bb8be0c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT = '/wiki/api/v2/trello/inbox/has-access';
let $26b2f47c8bb8be0c$var$cachedResult = null;
let $26b2f47c8bb8be0c$var$fetchPromise = null;
function $26b2f47c8bb8be0c$export$66160e11912cf1e6() {
    $26b2f47c8bb8be0c$var$cachedResult = null;
    $26b2f47c8bb8be0c$var$fetchPromise = null;
}
function $26b2f47c8bb8be0c$var$cacheErrorResult() {
    const result = {
        hasTrelloAccess: false,
        loading: false,
        error: true
    };
    $26b2f47c8bb8be0c$var$cachedResult = result;
    return result;
}
function $26b2f47c8bb8be0c$export$52c51aee2d49bb7f() {
    if (!$26b2f47c8bb8be0c$var$fetchPromise) $26b2f47c8bb8be0c$var$fetchPromise = Promise.resolve().then(()=>fetch($26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            }
        })).then(async (response)=>{
        if (!response.ok) {
            $26b2f47c8bb8be0c$var$logger.warn`Failed to check Trello access: status=${response.status}`;
            return $26b2f47c8bb8be0c$var$cacheErrorResult();
        }
        const data = await response.json();
        const result = {
            hasTrelloAccess: Boolean(data.hasTrelloAccess),
            loading: false,
            error: false
        };
        $26b2f47c8bb8be0c$var$cachedResult = result;
        return result;
    }).catch((error)=>{
        $26b2f47c8bb8be0c$var$logger.error`Error checking Trello access: ${error}`;
        return $26b2f47c8bb8be0c$var$cacheErrorResult();
    });
    return $26b2f47c8bb8be0c$var$fetchPromise;
}
const $26b2f47c8bb8be0c$export$955874e1badc4683 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [state, setState] = (0, $42omo.useState)($26b2f47c8bb8be0c$var$_temp);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if ($26b2f47c8bb8be0c$var$cachedResult) {
                setState($26b2f47c8bb8be0c$var$cachedResult);
                return;
            }
            let cancelled = false;
            $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
                if (!cancelled) setState(result);
            });
            return ()=>{
                cancelled = true;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    return state;
} : ()=>{
    const [state, setState] = (0, $42omo.useState)(()=>$26b2f47c8bb8be0c$var$cachedResult ?? {
            hasTrelloAccess: false,
            loading: true,
            error: false
        });
    (0, $42omo.useEffect)(()=>{
        if ($26b2f47c8bb8be0c$var$cachedResult) {
            setState($26b2f47c8bb8be0c$var$cachedResult);
            return;
        }
        let cancelled = false;
        $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
            if (!cancelled) setState(result);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    return state;
};
function $26b2f47c8bb8be0c$var$_temp() {
    return $26b2f47c8bb8be0c$var$cachedResult ?? {
        hasTrelloAccess: false,
        loading: true,
        error: false
    };
}
module.exports["prefetchTrelloAccess"] = $26b2f47c8bb8be0c$export$52c51aee2d49bb7f;
module.exports["useTrelloAccess"] = $26b2f47c8bb8be0c$export$955874e1badc4683;

});

parcelRegister("l4eiF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $79f107ddc4d1b489$var$defaultState = {
    firstHighlightShown: false
};
const $79f107ddc4d1b489$export$ca9047e33beaf8b2 = (0, $42omo.createContext)($79f107ddc4d1b489$var$defaultState);
$79f107ddc4d1b489$export$ca9047e33beaf8b2.displayName = 'HighlightActionsContext';
module.exports["HighlightActionsContext"] = $79f107ddc4d1b489$export$ca9047e33beaf8b2;

});

parcelRegister("b1ynj", function(module, exports) {
/* OtherActions.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $4KS7f = parcelRequire("4KS7f");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $1s5hv = parcelRequire("1s5hv");


var $9VJDA = parcelRequire("9VJDA");


var $jdPfT = parcelRequire("jdPfT");


var $tvI67 = parcelRequire("tvI67");


var $lGgRw = parcelRequire("lGgRw");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $gj7hi = parcelRequire("gj7hi");


var $inPa6 = parcelRequire("inPa6");




var $2GVu1 = parcelRequire("2GVu1");

var $6UWPx = parcelRequire("6UWPx");

var $bTiiT = parcelRequire("bTiiT");

var $iIVVb = parcelRequire("iIVVb");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4vC63 = parcelRequire("4vC63");


var $9fBoq = parcelRequire("9fBoq");


var $4GDP8 = parcelRequire("4GDP8");


var $1mDVg = parcelRequire("1mDVg");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $f5df649ae1312176$var$i18n = (0, $aXWIB.defineMessages)({
    selectApp: {
        id: "highlight-actions.select.app",
        defaultMessage: "Select app"
    },
    apps: {
        id: "highlight-actions.dropdown-group.apps",
        defaultMessage: "Apps"
    }
});
const $f5df649ae1312176$var$oldDropdownTriggerWrapperStyle = null;
const $f5df649ae1312176$var$dropdownTriggerWrapperStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5df649ae1312176$var$PopupPaddingContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt44ar7",
            __cmplp.className
        ])
    });
});
const $f5df649ae1312176$var$dropdownComponentListStyle = null;
const $f5df649ae1312176$var$iconImageStyle = null;
const $f5df649ae1312176$var$noIconWrapperStyle = null;
const $f5df649ae1312176$export$c01fdef1354c759b = ({ builtInActions: builtInActions = [], connectItems: connectItems, forgeItems: forgeItems = [], selectForgeExtension: selectForgeExtension = ()=>{} })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const fireOverflowMenuAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                name: 'button clicked - highlightActionsMenuOverflow',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuOverflow',
                source: 'highlightActionsMenu',
                type: 'ui',
                attributes: {
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const connectComponents = (0, $42omo.useMemo)(()=>connectItems.map((item)=>{
            if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $2GVu1.ToolbarDropdownItem), {
                key: item.completeKey,
                "data-vc": "link-item",
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    alt: item.label,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    size: "small",
                    label: ""
                })
            }, item.label);
            return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ $42omo.createElement("div", {
                className: item.styleClass
            }, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
                key: item.completeKey,
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: ""
                })
            }, item.label)) : /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                iconBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_2rko1rr0 _1bsb1tcg _4t3i1tcg _bfhkby5v _1e0c1txw _4cvr1h6o _1bah1b1v"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: "No icon",
                    color: "var(--ds-icon-disabled, #080F214A)"
                })),
                key: item.completeKey,
                appearance: "subtle",
                "data-key": item.completeKey,
                className: item.styleClass,
                href: item.url,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                shouldFitContainer: true,
                title: item.label
            }, item.label);
        }), [
        connectItems
    ]);
    const forgeComponents = (0, $42omo.useMemo)(()=>forgeItems.map((item)=>{
            const appTitle = (0, $9fBoq.extensionTitle)(item);
            if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $2GVu1.ToolbarDropdownItem), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    size: "small",
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle));
            return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle)) : /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                key: item.id,
                id: item.id,
                appearance: "subtle",
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    paddingLeft: connectItems.length ? '40px' : '8px',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                },
                shouldFitContainer: true,
                title: appTitle
            }, appTitle));
        }), [
        connectItems,
        forgeItems,
        selectForgeExtension,
        experienceTracker
    ]);
    const forgeKeyboardShortcuts = (0, $42omo.useMemo)(()=>forgeItems.map((module)=>/*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcut), {
                key: module.id,
                module: module,
                action: ()=>{
                    (0, $4GDP8.openContextMenuClick)();
                    (0, $4GDP8.simulateItemClick)(module.id);
                    (0, $4GDP8.simulateItemMouseOver)(module.id);
                }
            })), [
        forgeItems
    ]);
    const dropDownComponents = (0, $42omo.useMemo)(()=>{
        const oldToolbarComponents = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_18s8ax2b _1e0c1txw _2lx21bp4 _ca0qu2gc _n3tdu2gc _18m91wug _c71l1mjv _p12f1mjv"
            ])
        }, connectComponents, forgeComponents);
        return isNewToolbarEnabled ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $6UWPx.ToolbarDropdownItemSection), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $42omo.createElement((0, $6UWPx.ToolbarDropdownItemSection), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : oldToolbarComponents;
    }, [
        isNewToolbarEnabled,
        builtInActions,
        connectItems.length,
        forgeItems.length,
        intl,
        connectComponents,
        forgeComponents
    ]);
    if (isNewToolbarEnabled) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
        if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $bTiiT.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                size: "small"
            }),
            id: "context-menu-other-apps",
            testId: "context-menu-other-apps",
            onClick: fireOverflowMenuAnalytics,
            tooltipComponent: /*#__PURE__*/ $42omo.createElement((0, $iIVVb.ToolbarTooltip), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            })
        }, dropDownComponents, forgeKeyboardShortcuts);
        return /*#__PURE__*/ $42omo.createElement((0, $iIVVb.ToolbarTooltip), {
            content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
        }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            isOpen: isOpen,
            onOpenChange: (attrs)=>{
                setIsOpen(attrs.isOpen);
            },
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ $42omo.createElement("div", {
                    ...triggerProps,
                    ref: triggerRef,
                    id: "context-menu-other-apps",
                    "data-testid": "context-menu-other-apps",
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                    appearance: "subtle",
                    isSelected: isOpen,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                    testId: "highlight-actions-show-more",
                    onClick: fireOverflowMenuAnalytics
                }), forgeKeyboardShortcuts)
        }, dropDownComponents));
    }
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
    } else {
        if (!connectItems.length && !forgeItems.length) return null;
    }
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                ...triggerProps,
                ref: triggerProps.triggerRef,
                id: "context-menu-other-apps",
                "data-testid": "context-menu-other-apps",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                appearance: "subtle",
                isSelected: isOpen,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                isTooltipDisabled: false,
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                testId: "highlight-actions-show-more",
                onClick: fireOverflowMenuAnalytics
            }), forgeKeyboardShortcuts)
    }, dropDownComponents) : /*#__PURE__*/ $42omo.createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ $42omo.createElement($f5df649ae1312176$var$PopupPaddingContainer, null, dropDownComponents),
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                ...triggerProps,
                className: (0, $gMc0m.default)([
                    (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && "_1yt4v77o _1e0c1txw _4cvr1h6o _f7xt1osq _16711osq _5jgi1h6o _1d841h6o"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            }, (tooltipProps)=>/*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                    ...tooltipProps,
                    id: "context-menu-other-apps",
                    "aria-expanded": isOpen,
                    appearance: "subtle",
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    iconBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "",
                        spacing: "spacious",
                        testId: "highlight-actions-show-more"
                    }) : /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                        alignItems: "center",
                        gap: "space.050"
                    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                        label: ""
                    }), /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "Drop down",
                        testId: "highlight-actions-show-more",
                        size: "small"
                    })),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        margin: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? undefined : "var(--ds-space-025, 2px)",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        marginLeft: "var(--ds-space-negative-025, -2px)"
                    },
                    testId: "context-menu-other-apps"
                })), forgeKeyboardShortcuts),
        shouldRenderToParent: true
    });
};
module.exports["OtherActions"] = $f5df649ae1312176$export$c01fdef1354c759b;

});

parcelRegister("97kfW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $12914a8fd53705f4$var$lightBlueColor = '#2684FF';
const $12914a8fd53705f4$var$blueColor = '#0052CC';
const $12914a8fd53705f4$var$greyColor = "var(--ds-icon-disabled, #080F214A)";
const $12914a8fd53705f4$export$eaf821108be3620b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(53);
    const { greyed: t1, size: t2 } = t0;
    const greyed = t1 === undefined ? false : t1;
    const size = t2 === undefined ? "small" : t2;
    const t3 = size === "smaller" ? "16" : size === "small" ? "18" : "24";
    const t4 = size === "smaller" ? "16" : size === "small" ? "18" : "24";
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
            fill: "url(#paint0_linear_1733_293438)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: "url(#paint1_linear_1733_293438)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: "url(#paint2_linear_1733_293438)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
            fill: "url(#paint3_linear_1733_293438)"
        });
        $[0] = t5;
        $[1] = t6;
        $[2] = t7;
        $[3] = t8;
    } else {
        t5 = $[0];
        t6 = $[1];
        t7 = $[2];
        t8 = $[3];
    }
    const t9 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t10;
    if ($[4] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: t9
        });
        $[4] = t9;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t12;
    if ($[6] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: t11
        });
        $[6] = t11;
        $[7] = t12;
    } else t12 = $[7];
    const t13 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t14;
    if ($[8] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: t13
        });
        $[8] = t13;
        $[9] = t14;
    } else t14 = $[9];
    const t15 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t16;
    if ($[10] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: t15
        });
        $[10] = t15;
        $[11] = t16;
    } else t16 = $[11];
    const t17 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t18;
    if ($[12] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.270833",
            stopColor: t17
        });
        $[12] = t17;
        $[13] = t18;
    } else t18 = $[13];
    const t19 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t20;
    if ($[14] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "1",
            stopColor: t19
        });
        $[14] = t19;
        $[15] = t20;
    } else t20 = $[15];
    let t21;
    if ($[16] !== t18 || $[17] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint0_linear_1733_293438",
            x1: "20.9999",
            y1: "12",
            x2: "17.4999",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, t18, t20);
        $[16] = t18;
        $[17] = t20;
        $[18] = t21;
    } else t21 = $[18];
    const t22 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t23;
    if ($[19] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.1875",
            stopColor: t22
        });
        $[19] = t22;
        $[20] = t23;
    } else t23 = $[20];
    const t24 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t25;
    if ($[21] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "1",
            stopColor: t24
        });
        $[21] = t24;
        $[22] = t25;
    } else t25 = $[22];
    let t26;
    if ($[23] !== t23 || $[24] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint1_linear_1733_293438",
            x1: "12.5",
            y1: "3",
            x2: "12.5",
            y2: "6.5",
            gradientUnits: "userSpaceOnUse"
        }, t23, t25);
        $[23] = t23;
        $[24] = t25;
        $[25] = t26;
    } else t26 = $[25];
    const t27 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t28;
    if ($[26] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            stopColor: t27
        });
        $[26] = t27;
        $[27] = t28;
    } else t28 = $[27];
    const t29 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t30;
    if ($[28] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.791667",
            stopColor: t29
        });
        $[28] = t29;
        $[29] = t30;
    } else t30 = $[29];
    let t31;
    if ($[30] !== t28 || $[31] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint2_linear_1733_293438",
            x1: "6.82996",
            y1: "12",
            x2: "3.32996",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, t28, t30);
        $[30] = t28;
        $[31] = t30;
        $[32] = t31;
    } else t31 = $[32];
    const t32 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t33;
    if ($[33] !== t32) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            stopColor: t32
        });
        $[33] = t32;
        $[34] = t33;
    } else t33 = $[34];
    const t34 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t35;
    if ($[35] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.802083",
            stopColor: t34
        });
        $[35] = t34;
        $[36] = t35;
    } else t35 = $[36];
    let t36;
    if ($[37] !== t33 || $[38] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint3_linear_1733_293438",
            x1: "12.5",
            y1: "16.9999",
            x2: "12.5",
            y2: "20.9999",
            gradientUnits: "userSpaceOnUse"
        }, t33, t35);
        $[37] = t33;
        $[38] = t35;
        $[39] = t36;
    } else t36 = $[39];
    let t37;
    if ($[40] !== t21 || $[41] !== t26 || $[42] !== t31 || $[43] !== t36) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t21, t26, t31, t36);
        $[40] = t21;
        $[41] = t26;
        $[42] = t31;
        $[43] = t36;
        $[44] = t37;
    } else t37 = $[44];
    let t38;
    if ($[45] !== t10 || $[46] !== t12 || $[47] !== t14 || $[48] !== t16 || $[49] !== t3 || $[50] !== t37 || $[51] !== t4) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: t3,
            height: t4,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t5, t6, t7, t8, t10, t12, t14, t16, t37);
        $[45] = t10;
        $[46] = t12;
        $[47] = t14;
        $[48] = t16;
        $[49] = t3;
        $[50] = t37;
        $[51] = t4;
        $[52] = t38;
    } else t38 = $[52];
    return t38;
} : ({ greyed: greyed = false, size: size = 'small' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
        fill: "url(#paint0_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "url(#paint1_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "url(#paint2_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
        fill: "url(#paint3_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_1733_293438",
        x1: "20.9999",
        y1: "12",
        x2: "17.4999",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.270833",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint1_linear_1733_293438",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.1875",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint2_linear_1733_293438",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.791667",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint3_linear_1733_293438",
        x1: "12.5",
        y1: "16.9999",
        x2: "12.5",
        y2: "20.9999",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.802083",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }))));
module.exports["AtlassianIntelligenceIcon"] = $12914a8fd53705f4$export$eaf821108be3620b;

});

parcelRegister("5iBet", function(module, exports) {

let $3dbb83cc91d556d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3dbb83cc91d556d0$var$load("hpN5y").then(()=>parcelRequire('jhEjP'));

});

parcelRegister("41AE3", function(module, exports) {

let $2ee3ae603a61aa60$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ee3ae603a61aa60$var$load("6wr18"),
    $2ee3ae603a61aa60$var$load("ffEVr"),
    $2ee3ae603a61aa60$var$load("5GaTI"),
    $2ee3ae603a61aa60$var$load("aSmvL")
]).then(()=>parcelRequire('1TWCG'));

});


//# sourceMappingURL=SelectionComponent.456c62a9.js.map
